
import { Card } from "@/components/ui/card";

const Roadmap = () => {
  const phases = [
    {
      number: "Phase 1",
      title: "Hull Breach",
      description: "Launch & liquidity adds",
      status: "upcoming"
    },
    {
      number: "Phase 2",
      title: "Money-Count",
      description: "CEX listings & whale alerts",
      status: "upcoming"
    },
    {
      number: "Phase 3",
      title: "Outlaws Deploy",
      description: "First marine cleanups live",
      status: "upcoming"
    },
    {
      number: "Phase 4",
      title: "Deep Dive",
      description: "DAO & pirate-style governance",
      status: "upcoming"
    },
    {
      number: "Phase 5",
      title: "Ethereum Tide",
      description: "V2 launch on Ethereum",
      status: "upcoming"
    },
    {
      number: "Phase 6",
      title: "Whale Whisper",
      description: "Involve Vitalik Buterin",
      status: "upcoming"
    },
    {
      number: "Phase 7",
      title: "Popchain Forge",
      description: "Fork to our own Proof-of-Work Blockchain",
      status: "upcoming"
    }
  ];

  return (
    <section 
      id="roadmap" 
      className="py-24 relative bg-black"
    >
      {/* Background image as a separate div with fixed positioning */}
      <div 
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: "url('/lovable-uploads/1ba5a413-bc7f-42a1-aae0-5ea300a6ef5a.png')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundAttachment: "fixed",
          opacity: 0.6,
        }}
      ></div>
      
      <div className="container mx-auto px-4 relative z-10">
        <h2 className="text-3xl md:text-4xl font-bold mb-16 text-center">
          <span className="bg-clip-text text-transparent bg-gradient-to-r from-orange-400 to-orange-600">
            The Grand Heist at Sea
          </span>
        </h2>

        <div className="max-w-5xl mx-auto">
          {/* Vertical timeline for desktop */}
          <div className="hidden md:block relative">
            {/* Center line */}
            <div className="absolute left-1/2 transform -translate-x-1/2 h-full w-1 bg-gradient-to-b from-orange-600/20 via-orange-500/60 to-orange-600/20 rounded-full"></div>
            
            <div className="relative">
              {phases.map((phase, index) => (
                <div key={index} className={`mb-16 flex items-center ${index % 2 === 0 ? 'justify-start' : 'justify-end'}`}>
                  <div className={`w-5/12 ${index % 2 === 0 ? 'pr-10 text-right' : 'pl-10 text-left'}`}>
                    <Card className="bg-black/80 border border-orange-500/20 shadow-lg p-6 transition-all duration-300 hover:border-orange-500/40 hover:shadow-orange-500/10">
                      <span className="inline-block px-3 py-1 mb-3 text-xs font-semibold bg-orange-500/10 text-orange-400 rounded-full">
                        {phase.number}
                      </span>
                      <h3 className="text-xl font-bold mb-2 text-white">{phase.title}</h3>
                      <p className="text-gray-400">{phase.description}</p>
                    </Card>
                  </div>

                  {/* Center dot */}
                  <div className="absolute left-1/2 transform -translate-x-1/2 w-6 h-6 bg-orange-500 rounded-full border-4 border-transparent z-10 shadow-lg shadow-orange-500/20"></div>
                </div>
              ))}
            </div>
          </div>

          {/* Mobile timeline */}
          <div className="md:hidden relative">
            <div className="absolute left-4 top-0 h-full w-1 bg-gradient-to-b from-orange-600/20 via-orange-500/60 to-orange-600/20"></div>
            
            {phases.map((phase, index) => (
              <div key={index} className="relative pl-12 mb-10">
                <div className="absolute left-0 w-8 h-8 bg-orange-500 rounded-full border-4 border-transparent z-10"></div>
                
                <Card className="bg-black/80 border border-orange-500/20 shadow-lg p-6">
                  <span className="inline-block px-3 py-1 mb-3 text-xs font-semibold bg-orange-500/10 text-orange-400 rounded-full">
                    {phase.number}
                  </span>
                  <h3 className="text-xl font-bold mb-2 text-white">{phase.title}</h3>
                  <p className="text-gray-400">{phase.description}</p>
                </Card>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Roadmap;
